"use strict";

exports.__esModule = true;
exports.default = exports.Checkbox = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _useFormElementValidation = _interopRequireDefault(require("../../hooks/useFormElementValidation"));

var _useRandomId = _interopRequireDefault(require("../../hooks/useRandomId"));

var _useLabel3 = _interopRequireDefault(require("../../hooks/useLabel"));

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

var _excluded = ["id", "name", "checked", "label", "helper", "required", "disabled", "readOnly", "size", "color", "align", "outline", "onChange", "onBlur", "onError", "containerLabel", "displayAsButton", "isIndeterminate", "className", "children", "inputClassName"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * The Checkbox component allows the user to make a binary choice, i.e. a choice between one of two possible mutually exclusive options.
 */
var Checkbox = function Checkbox(props) {
  var controlledId = props.id,
      name = props.name,
      controlledChecked = props.checked,
      initialLabel = props.label,
      helper = props.helper,
      required = props.required,
      disabled = props.disabled,
      readOnly = props.readOnly,
      size = props.size,
      _props$color = props.color,
      color = _props$color === void 0 ? 'primary' : _props$color,
      align = props.align,
      outline = props.outline,
      onChange = props.onChange,
      onBlur = props.onBlur,
      onError = props.onError,
      initialContainerLabel = props.containerLabel,
      displayAsButton = props.displayAsButton,
      isIndeterminate = props.isIndeterminate,
      className = props.className,
      children = props.children,
      inputClassName = props.inputClassName,
      attributes = _objectWithoutPropertiesLoose(props, _excluded);

  var checkboxRef = _react.default.useRef(null);

  var id = _react.default.useRef((0, _useRandomId.default)(controlledId)).current;

  var _React$useState = _react.default.useState(controlledChecked || false),
      checked = _React$useState[0],
      setChecked = _React$useState[1];

  var _React$useState2 = _react.default.useState(false),
      error = _React$useState2[0],
      setError = _React$useState2[1];

  var _useFormElementValida = (0, _useFormElementValidation.default)(checked, {
    required: required
  }),
      errors = _useFormElementValida[0],
      methods = _useFormElementValida[1];

  var _useLabel = (0, _useLabel3.default)(initialLabel, _extends({}, props, {
    id: id,
    required: required && !initialContainerLabel
  }), false),
      label = _useLabel.label;

  var _useLabel2 = (0, _useLabel3.default)(initialContainerLabel, _extends({}, props, {
    id: id,
    required: required
  }), false),
      containerLabel = _useLabel2.label;

  _react.default.useEffect(function () {
    setChecked(controlledChecked || false);
  }, [controlledChecked]);

  _react.default.useEffect(function () {
    setError(errors.length > 0);
  }, [errors]);

  var handleChange = function handleChange(event) {
    methods.onChangeCheckbox(event);
    setChecked(event.target.checked);

    if (typeof onChange === 'function') {
      onChange(event.target.checked, checkboxRef.current.name, event);
    }
  };

  var handleBlur = function handleBlur(event) {
    methods.onChangeCheckbox(event);

    if (typeof onBlur === 'function') {
      onBlur(event.target.id);
    }
  };

  var classes = (0, _clsx.default)('uk-form-item', 'uk-checkbox', displayAsButton && 'uk-checkbox--button', size !== 'default' && size, align !== 'left' && 'right', disabled && 'disabled', helper.length > 0 && 'has-helper', errors.length > 0 && 'has-error', className);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes
  }, containerLabel && /*#__PURE__*/_react.default.createElement("div", {
    className: "checkbox-container-label"
  }, containerLabel), /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: id,
    className: (0, _clsx.default)('flex-container', label && align !== 'left' && align)
  }, /*#__PURE__*/_react.default.createElement("input", _extends({
    ref: checkboxRef,
    id: id,
    name: name || id,
    type: "checkbox",
    checked: checked,
    className: "uk-checkable",
    disabled: disabled,
    readOnly: readOnly,
    required: required,
    onChange: handleChange,
    onBlur: handleBlur,
    "aria-checked": (checked && isIndeterminate ? 'mixed' : undefined) || checked,
    "aria-describedby": (name || id) + "-helper-text " + (name || id) + "-required-message"
  }, attributes)), !displayAsButton ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
    className: "uk-fake-input " + (outline ? "uk-outline--" + color : checked ? "uk-bghcolor--" + color : '')
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: isIndeterminate ? 'indeterminate' : 'checkmark'
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-checkable__label"
  }, label)) : /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-checkable__label " + (outline ? "uk-outline--" + color : checked ? "uk-bghcolor--" + color + " uk-color--white" : '')
  }, label || children)), (helper.length > 0 || error) && /*#__PURE__*/_react.default.createElement("small", {
    className: "helper",
    id: (name || id) + "-helper-text"
  }, error ? errors : helper));
};

exports.Checkbox = Checkbox;
Checkbox.propTypes = {
  /**
   * ID of the Checkbox (used to bind the label to the Checkbox)
   * NB: the ID will be randomly generated if not set.
   */
  id: _propTypes.default.string,

  /**
   * Name of the Checkbox (used instead of the ID when submitted)
   */
  name: _propTypes.default.string,

  /**
   * Label of the Checkbox
   */
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),

  /**
   * Helper text, is replaced by a message in case of error
   */
  helper: _propTypes.default.string,

  /**
   * Change the display of the Checkbox
   */
  displayAsButton: _propTypes.default.bool,

  /**
   * Position of the Checkbox relative to its label
   */
  align: _propTypes.default.oneOf(['left', 'right', 'vertical']),

  /**
   * Size of the Checkbox
   */
  size: _propTypes.default.oneOf(['tiny', 'small', 'default', 'large', 'big']),

  /**
   * Background-color of a selected Checkbox (or checkmark color if outline)
   */
  color: _propTypes.default.oneOf(['default', 'primary', 'secondary', 'success', 'alert', 'warning', 'white']),

  /**
   * Invert styling colors of the Checkbox
   */
  outline: _propTypes.default.bool,

  /**
   * Set the Checkbox as selected
   */
  checked: _propTypes.default.bool,

  /**
   * Add a high-level label
   */
  containerLabel: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),

  /**
   * Set the Checkbox as read-only
   */
  readOnly: _propTypes.default.bool,

  /**
   * Set the Checkbox as disabled
   */
  disabled: _propTypes.default.bool,

  /**
   * Form-validation: set the Checkbox as required
   */
  required: _propTypes.default.bool,

  /**
   * classes of checkbox's Input
   */
  inputClassName: _propTypes.default.string,

  /**
   * Is checkbox state indeterminate (3d state)
   */
  isIndeterminate: _propTypes.default.bool,

  /**
   * Callback function onChange
   */
  onChange: _propTypes.default.func,

  /**
   * Callback function onBlur
   */
  onBlur: _propTypes.default.func,

  /**
   * Callback function onError
   */
  onError: _propTypes.default.func
};
Checkbox.defaultProps = {
  helper: '',
  displayAsButton: false,
  align: 'left',
  size: 'default',
  color: 'primary',
  readOnly: false,
  disabled: false,
  required: false,
  inputClassName: '',
  isIndeterminate: false
};
var _default = Checkbox;
exports.default = _default;